import script from "./CustomerInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerInfo.vue?vue&type=script&setup=true&lang=js"

import "./CustomerInfo.vue?vue&type=style&index=0&id=708f8419&lang=css"

const __exports__ = script;

export default __exports__